import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Constant, DB } from './constants';
import LanguageDetector from 'i18next-browser-languagedetector';

const getTranslationConfigByCurrentLanguage = async () => {
  const currentLanguage = localStorage.getItem(Constant.localStorageKey.currentLanguage);
  const translationConfigDataQuery = await DB.translationConfigData.toArray();
  const currentLanguageConfig = translationConfigDataQuery.filter((config) => config.language === currentLanguage);
  if (currentLanguageConfig.length > 0){
      const translationConfig = currentLanguageConfig[0].config.datahydrotest;
      return translationConfig;
  }

  return [];
};

let currentLanguage = localStorage.getItem(Constant.localStorageKey.currentLanguage);
if (!currentLanguage) {
  currentLanguage = 'fr-FR';
  localStorage.setItem(Constant.localStorageKey.currentLanguage, currentLanguage);
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init(
    {
      fallbackLng: 'fr',
      resources: {
        en: {
            translation: {
                enterReportTitle: 'ENTER A REPORT',
                pendingReports: 'PENDING REPORTS',
                synchronizedReports: 'SYNCHRONIZED REPORTS',
                back: 'Back',
                home: 'Home',
                cancel: 'Cancel',
                confirm: 'Confirm',
                password: 'Password *',
                user: 'User',
                username: 'Username *',
                connect: 'Login',
                fieldRequire: 'This field is require *',
                invalidPassword: 'Invalid password',
                invalidUsernameOrPassword: 'Invalid username or password',
                alert: 'Alert',
                noConnection: 'No internet connection',
                reportAddedToWaitingForSynchronize: 'The report has been added to the list of reports awaiting synchronization.',
                languageNotAvailable: 'Something went wrong, this language is not available at the moment.',
                questionNotCompleted: 'A question in the form is not completed.',
                noMoreCredits: "Warning, you no longer have credit to record your periodic checks.",
                noPointsFound: "No points found for the user.",
                remainingPoints: "You had <strong>{{count}}</strong> point left to carry out your checks,<br/>during your last connection on {{date}}.",
                remainingPoints_plural: "You had <strong>{{count}}</strong> points left to carry out your checks,<br/>during your last connection on {{date}}.",
                noMorePointsForControl: "You no longer have points to perform a new check. You need to place a new order of points."
            }
        },
        it: {
            translation: {
                noMoreCredits: "Attenzione, non hai più credito per registrare i tuoi controlli periodici.",
                noPointsFound: "Nessun punto trovato per l’utente.",
                remainingPoints: "Ti rimaneva <strong>{{count}}</strong> punto per effettuare i tuoi controlli,<br/>durante l’ultimo accesso del {{date}}.",
                remainingPoints_plural: "Ti rimanevano <strong>{{count}}</strong> punti per effettuare i tuoi controlli,<br/>durante l’ultimo accesso del {{date}}.",
                noMorePointsForControl: "Non hai più punti per effettuare un nuovo controllo. Devi effettuare un nuovo ordine di punti."
            }
        },
        fr: {
            translation: {
                enterReportTitle: 'SAISIR UN RAPPORT',
                pendingReports: 'RAPPORTS EN ATTENTE',
                synchronizedReports: 'RAPPORTS SYNCHRONISES',
                back: 'Retour',
                home: 'Accueil',
                cancel: 'Annuler',
                confirm: 'Confirmer',
                password: 'Mot de passe *',
                user: 'Utilisateur',
                username: 'Identifiant *',
                connect: 'connexion',
                fieldRequire: 'Ce champ est requis *',
                invalidPassword: 'Mot de passe invalide',
                invalidUsernameOrPassword: "Nom d'utilisateur ou mot de passe invalide!",
                alert: 'Alerte',
                noConnection: 'Pas de connexion internet!',
                reportAddedToWaitingForSynchronize: 'Le rapport a été ajouté à la liste des rapports en attente de synchronisation.',
                languageNotAvailable: "Une erreur s'est produite, cette langue n'est pas disponible pour le moment.",
                questionNotCompleted: "Une question du formulaire n'est pas complétée.",
                noMoreCredits: "Attention vous n'avez plus de crédit pour enregistrer vos contrôles périodiques.",
                noPointsFound: "Aucun point trouvé pour l'utilisateur.",
                remainingPoints: "Il vous restait <strong>{{count}}</strong> point pour réaliser vos contrôles,<br/>lors de votre dernière connexion le {{date}}.",
                remainingPoints_plural: "Il vous restait <strong>{{count}}</strong> points pour réaliser vos contrôles,<br/>lors de votre dernière connexion le {{date}}.",
                noMorePointsForControl: "Vous ne disposez plus de point pour réaliser un nouveau contrôle. Vous devez passer une nouvelle commande de points."
            }
        }
      },
    },
    async (err, t) => {
      if (err) {
        console.error(err);
        return;
      }

      const translationConfig = await getTranslationConfigByCurrentLanguage();
      
      // Add the translation data for the current language
      i18next.addResourceBundle(currentLanguage, 'translation', translationConfig, true, true);

      // Update the language when it changes
      i18next.on('languageChanged', async (lng) => {
        const translationConfig = await getTranslationConfigByCurrentLanguage();

        // Add the translation data for the new language
        i18next.addResourceBundle(lng, 'translation', translationConfig, true, true);
      });
    },
  );

export default i18next;
